<section class="flex flex-col gap-5">
  <div>
    <out-text
      tag="h3"
      class="font-semibold text-3xl"
      content="Leave us a message"
    ></out-text>
    <p>Reach out with your inquiries, and we’ll get back to you shortly.</p>
  </div>

  <!-- Error Alert Box -->
  <div
    *ngIf="formErrors.length > 0"
    class="bg-[#f9e7e9] p-[20px_20px_10px] rounded m-[15px_0_15px]"
  >
    <out-text
      class="mb-[10px] text-[calc(14px_+_(400vw_-_1280px)/1360)] lg:text-[18px] lg:leading-[26px]"
      content="Please correct the following errors:"
    ></out-text>
    <ul
      class="list-disc text-[calc(14px_+_(400vw_-_1280px)/1360)] lg:text-[18px] lg:leading-[26px] space-y-[5px] ms-[20px] mb-[5px]"
    >
      <li *ngFor="let error of formErrors">{{ error }}</li>
    </ul>
  </div>

  <!-- Form -->
  <form (ngSubmit)="onSubmit()" [formGroup]="enquiryForm" novalidate>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-2.5 lg:gap-x-4">
      <!-- First Name -->
      <out-input
        [id]="'firstName'"
        [name]="'firstName'"
        [label]="'First name'"
        [required]="true"
        [control]="getControl('firstName')"
        [type]="'tel'"
        [errorMessage]="'Must provide a first name.'"
        (valueChange)="onControlChange('firstName', $event)"
        [acl]="''"
      ></out-input>

      <!-- Last Name -->
      <out-input
        [id]="'lastName'"
        [name]="'lastName'"
        [label]="'Last name'"
        [required]="true"
        [control]="getControl('lastName')"
        [type]="'tel'"
        [errorMessage]="'Must provide a  last name.'"
        (valueChange)="onControlChange('lastName', $event)"
        [acl]="''"
      ></out-input>
    </div>

    <section>
      <!-- Telephone -->
      <out-input
        [id]="'telephone'"
        [name]="'telephone'"
        [label]="'Telephone'"
        [control]="getControl('telephone')"
        [type]="'tel'"
        [errorMessage]="'Must provide a phone number.'"
        (valueChange)="onControlChange('telephone', $event)"
        [acl]="''"
      ></out-input>

      <out-input
        [id]="'email'"
        [name]="'email'"
        [label]="'Email'"
        [required]="true"
        [control]="getControl('email')"
        [type]="'tel'"
        [errorMessage]="'Must provide a valid email.'"
        (valueChange)="onControlChange('email', $event)"
        [acl]="''"
      ></out-input>
    </section>

    <out-input
      [id]="'message'"
      [name]="'Message'"
      [label]="'Message'"
      [required]="true"
      [control]="getControl('message')"
      [type]="'textarea'"
      [errorMessage]="'Must provide a message.'"
      (valueChange)="onControlChange('message', $event)"
      [acl]="'!h-[128px]'"
    ></out-input>

    <br class="hidden lg:block" />

    <!-- Submit Button -->
    <div>
      <out-button
        [disabled]="isSubmitting"
        label="Submit Enquiry →"
        loadingLabel="Sending"
        type="submit"
        [isLoading]="isSubmitting"
        buttonClass="!bg-OUT-Blue !hover:bg-blue-600 transition-colors duration-300 text-white py-2.5 mt-5 xl:mt-4 rounded-lg w-full disabled:bg-OUT-Blue/80 disabled:cursor-default cursor-pointer"
      >
      </out-button>
    </div>
  </form>
</section>

<out-alert></out-alert>
